'use strict';

var React = require('react');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const FilterWithSummary = React.forwardRef(({ items, onSelectionChange, icon = 'filter-filled', title, className, multiple, clearable = true, fullWidth = false, }, ref) => {
    const [open, setOpen] = React.useState(false);
    const handleChange = (event) => {
        const { value } = event.target;
        onSelectionChange(items.map(item => {
            const selected = !multiple ? item.value === value : item.value === value ? !item.selected : item.selected;
            return {
                ...item,
                selected,
            };
        }));
        if (!multiple) {
            setOpen(false);
        }
    };
    const handleClear = (event) => {
        event.stopPropagation();
        onSelectionChange(items.map(item => ({ ...item, selected: false })));
        setOpen(false);
    };
    const selectedItemsStr = items
        ?.filter(item => item.selected)
        .map(item => item.labelShort || item.label)
        .join(', ');
    const displayClearIcon = clearable && Boolean(selectedItemsStr);
    return (React__default.default.createElement(styles.Dropdown, { ref: ref, onOpenedChange: setOpen, target: React__default.default.createElement(React__default.default.Fragment, null,
            React__default.default.createElement(styles.ButtonTarget, { "$fullWidth": fullWidth, "$displayClearIcon": displayClearIcon, iconIntent: "primary", icon: icon, variant: "secondary" },
                React__default.default.createElement(styles.Title, null, title),
                selectedItemsStr ? React__default.default.createElement("span", null,
                    " : ",
                    selectedItemsStr) : null),
            displayClearIcon ? (React__default.default.createElement(styles.ButtonClear, { size: "s", iconIntent: "disabled", icon: "clear-filled", variant: "secondary", onClick: handleClear })) : null), variant: "align-left", isOpened: open, className: className },
        React__default.default.createElement(styles.Items, null, items.map(item => (React__default.default.createElement(styles.Checkbox, { checkboxHidden: !multiple, key: item.value, label: React__default.default.createElement(styles.ItemLabel, null, item.label), checked: item.selected, onChange: handleChange, disabled: item.disabled, value: item.value }))))));
});

exports.FilterWithSummary = FilterWithSummary;
//# sourceMappingURL=component.js.map
